export enum ESaveState {
    saved,
    unsaved,
    saving
}
